import React, { useContext, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import styled from "styled-components"
import SimpleFormInput from "../components/SimpleFormInput"
import SimpleTextArea from "../components/SimpleTextArea"
import { arrayUnion, collection, doc, onSnapshot, query, updateDoc, where } from "firebase/firestore"
import { db, useAuth } from "../firebase-config"
import { UserContext } from "../context/UserContextProvider"
import PrimaryBtn from "../components/PrimaryBtn"
import { toast, ToastContainer } from "react-toastify"

const AddAdmin = () => {
  const [toggleTab, setToggleTab] = useState(0)
  const [adminList, setAdminList] = useState([])
  const [activeAdmin, setActiveAdmin] = useState({})
  const {loggedInUser} = useContext(UserContext)
  const [isAddSubCat, setIsAddSubCat] = useState(false)
  const [categoryListArr, setCategoryListArr] = useState([])
  const [selectedCategory, setSelectedCategory] = useState('')
  const [subCategory, setSubCategory] = useState('')
  const navigate = useNavigate()
  const adminListArr = [
    {
      title: "Admin 1",
    },
    {
      title: "Admin 1",
    },
  ]

  const location = useLocation()

  const adminIt = {
    title: "Admin",
  }

  const fetchCategories = async () => {
    try {
      const categoryRef =  query(collection(db, 'category'))
     const unsub =   onSnapshot(categoryRef, querySnap => {
            setCategoryListArr(
                querySnap.docs.map((doc) => ({...doc.data(), id: doc.id}))
            )
        })
        return unsub
    } catch (error) {
        console.log(error)
    }
}

  const addSubCategory = async () => {
    if( !selectedCategory || !subCategory) return 
    try {
      const ref = doc(db, 'category', selectedCategory)
      updateDoc(ref, {
        subCat: arrayUnion({
          subCatName: subCategory,
          path: subCategory.trim().toLocaleLowerCase()
        })
      })
      toast.success('Added')
    } catch (error) {
      console.log(error)
    }
  }

  const addAdmin = () => {
    adminListArr = [...adminListArr, adminIt]
  }
  const handleTabBtn = (index, item) => {
    setToggleTab(index)
    setActiveAdmin(item)
  }

  const selectOnChange = e => {
    setSelectedCategory(e.target.value)
    console.log(e.target.value)
  }

  const toggleBtn = () => {
    setIsAddSubCat(!isAddSubCat)
    setToggleTab(null)
  }


  useEffect(() => {
    const userRef = collection(db, "users")
    const q = query(userRef, where("role", "==", "admin"))
    const unsub = onSnapshot(q, querySnapshot => {
      let users = []
      querySnapshot.forEach(doc => {
        users.push(doc.data())
      })
      setAdminList(users)
    })

    return () => {
        unsub()
    }
  }, [])

  useEffect(() => {
    const unsub = fetchCategories()

    return unsub
  }, [])
  

  useEffect(() => {
    if(loggedInUser.role !== 'admin'){
        navigate('/')
    }
  }, [])
  

  

  return (
    <>
    <ToastContainer limit={2} />
      <AddAdminOption>
        <label>Add new Admin</label>
        <AddAdminBtn onClick={addAdmin}>Add Admin</AddAdminBtn>
      </AddAdminOption>
      <AdminFormWrap>
        <VerticalTabBar>
          <AdminListArr>
            {adminList.map((item, index) => (
              <Tabbtn
                key={index}
                onClick={() => handleTabBtn(index, item)}
                className={
                  toggleTab === index ||
                  location.hash.replace("%20", " ", "#", "").substring(1) ===
                    item.title
                    ? "active-tab"
                    : ""
                }
              >
                {item.personalInfo?.name}
              </Tabbtn>
            ))}
            <Tabbtn className={
                   isAddSubCat
                    ? "active-tab"
                    : ""
                } onClick={toggleBtn}>
              Add SubCategory
            </Tabbtn>
          </AdminListArr>
          {/* <AddAdminBtn onClick={addAdmin}>Add Admin</AddAdminBtn> */}
        </VerticalTabBar>
        <AdminFormCont>
          {
            !isAddSubCat?
            <>
            <SimpleFormInput
              value={activeAdmin?.personalInfo?.name}
              btnLabel={"Edit"}
              label={"Name*:"}
            />
            {/* <SimpleFormInput  value={activeAdmin.personalInfo.job} btnLabel={'Edit'} label={"Job*:"} /> */}
            <SimpleFormInput
              value={activeAdmin?.personalInfo?.email}
              btnLabel={"Edit"}
              label={"Email*:"}
            />
            <SimpleFormInput
              value={activeAdmin?.personalInfo?.phone}
              btnLabel={"Edit"}
              label={"Phone*:"}
            />
            <SimpleFormInput
              value={activeAdmin?.personalInfo?.dob}
              btnLabel={"Edit"}
              label={"Date of Birth*:"}
            />
            <SimpleFormInput
              value={activeAdmin?.personalInfo?.gender}
              btnLabel={"Edit"}
              label={"Gender*:"}
            />
            <SimpleTextArea
              value={activeAdmin?.personalInfo?.address}
              btnLabel={"Edit"}
              label={"Address*:"}
            />
            <SimpleFormInput
              value={activeAdmin?.personalInfo?.country}
              btnLabel={"Edit"}
              label={"Country*:"}
            />
          </>
            :
            <div>
              <Select onChange={selectOnChange}>
                {
                  categoryListArr.map((item, index) => {
                    return (
                      <option value={item.id} key={index}>{item.cateName}</option>
                    )
                  })
                } 
              </Select>
            <SimpleFormInput
              value={subCategory}
              handleOnChange={(e) => setSubCategory(e.target.value)}
              btnLabel={"Edit"}
              label={"SubCagtegory*:"}
              />
              <PrimaryBtn handleBtn={addSubCategory} label="Add"  />
              </div>
          }
        </AdminFormCont>
        <span className="infotip_label">*requried to be filed</span>
      </AdminFormWrap>
    </>
  )
}

export default AddAdmin

const VerticalTabWrap = styled.div`
  display: flex;
`
const VerticalTabBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 90vh;
  width: 25%;
  max-width: 25%;
  background: ${({ theme }) => theme.background};
  /* background: cyan; */

  .active-tab {
    background: #dc1d13;
    transition: 500ms;
    cursor: pointer;
    color: #fff;
  }

  @media (max-width: 768px) {
    display: none;
  }
`
const AdminFormWrap = styled.div`
  display: flex;
  width: 100%;
  background: ${({ theme }) => theme.body};

  .infotip_label {
    position: absolute;
    bottom: -5rem;
    right: 1.5rem;
  }
`

const AdminListArr = styled.div`
  display: flex;
  flex-direction: column;
  height: 75vh;
  padding-top: 1.5rem;
  width: 100%;
  overflow-y: auto;
`
const Tabbtn = styled.button`
  color: ${({ theme }) => theme.text};
  text-decoration: none;
  border: none;
  background: none;
  padding: 0.6rem 0rem;
  transition: 500ms;
  cursor: pointer;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 1.1rem;
  line-height: 29px;
`
const AddAdminBtn = styled.button`
  color: #fff;
  text-decoration: none;
  border: none;
  background: ${({ theme }) => theme.accent};
  padding: 0.6rem 0.3rem;
  width: fit-content;
  height: 2.5rem;
  cursor: pointer;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 1.1rem;
`
const AdminFormCont = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1.5rem;
  background: ${({ theme }) => theme.body};

  @media (max-width: 768px) {
    height: 90vh;
  }
`
const AddAdminOption = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    padding: 1rem;
    background: ${({ theme }) => theme.body};
    align-items: center;
    label {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 500;
      font-size: 1.1rem;
      color: ${({ theme }) => theme.text};
    }
  }
`
const Select = styled.select`
  width: 100%;
  background: ${({ theme }) => theme.background};
  padding: 1rem 0.5rem;
  color: ${({ theme }) => theme.text};
`

